import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createCustomerLogin,
  getCustomer,
  getCustomerByID,
} from "../redux/actions/AdminAction";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CREATE_CUSTOMER_LOGIN_RESET } from "../Constants/Constants";
import { LoadingButton } from "@mui/lab";

export default function CustomerLogins() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user_id = JSON.parse(localStorage.getItem("user_id"));
  const [customer_id, setCustomer_id] = useState(null);
  const [customer_username, setCustomer_username] = useState(null);
  const [usernameError, setUsernameError] = useState("");
  const [password, setPassword] = useState(null);
  const [confirm_password, setConfirm_password] = useState(null);
  const [showPassword, setShowPassword] = useState(null);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);

  const GetCustomers = useSelector((state) => state.GetCustomers);
  const { customersInfo } = GetCustomers;

  const CreateCustomerLogin = useSelector((state) => state.CreateCustomerLogin);
  const { customerLoginInfo, error, loading } = CreateCustomerLogin;

  useEffect(() => {
    dispatch(getCustomer());
  }, []);

  useEffect(() => {
    if (customerLoginInfo) {
      setCustomer_id(null);
      setCustomer_username(null);
      setPassword(null);
      setConfirm_password(null);
    }
  }, [customerLoginInfo]);

  useEffect(() => {
    if (customerLoginInfo) {
      setSnackOpen(true);
      setTimeout(() => {
        dispatch({ type: CREATE_CUSTOMER_LOGIN_RESET });
        navigate("/managecustomerlogins");
      }, 5000);
    }
  }, [customerLoginInfo]);

  const handleClickShowNewPassword = () => setShowPassword((show) => !show);

  const handleClickConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
  };

  const generatePassword = () => {
    const length = 12; // Desired password length
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let newPassword = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      newPassword += charset[randomIndex];
    }
    setPassword(newPassword);
  };

  const validateEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmail = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());

    const invalidEmails = enteredValues.filter(
      (email) => email && !validateEmail(email)
    );

    if (invalidEmails.length > 0) {
      setUsernameError(`Invalid email addresses: ${invalidEmails.join(", ")}`);
    } else {
      setUsernameError("");
    }
    const enteredEmail = enteredValues.join(" ");

    setCustomer_username(enteredEmail);
  };

  const submitHandler = () => {
    if (customer_id || password) {
      // if (!password) {
      //   setErrorAlertTitle("Filed don't match");
      //   setErrorAlertMessage(
      //     "Password and confirm password don't match! Enter confirm password again"
      //   );
      //   setSnackOpen(true);
      //   setErrorAlert(true);
      // } else {
      const customer_login_data = {
        customer_id: customer_id,
        username: customer_username,
        password: password,
        created_by: user_id,
        is_active: true,
      };
      dispatch(createCustomerLogin(customer_login_data));
      setSnackOpen(true);
      setTimeout(() => {
        // setCustomer_id(null);
        // setCustomer_username(null);
        // setPassword(null);
        // setConfirm_password(null);
        dispatch({ type: CREATE_CUSTOMER_LOGIN_RESET });
      }, 3000);
      // }
    } else {
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage(
        "Please select a customer and enter a password to proceed."
      );
      setErrorAlert(true);
      setSnackOpen(true);
    }
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box>
        <Box sx={{ margin: 3, fontSize: 25 }}>
          Manage your customers
          <Divider sx={{ marginTop: 2 }} />
        </Box>
        <Box sx={{ fontSize: 25, margin: 3 }}>Customer Logins</Box>
        <Box sx={{ margin: 3 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid item xs={6}>
                Customer name
              </Grid>
              <Grid item xs={6} mt={1}>
                <Autocomplete
                  size="medium"
                  //   sx={{ width: "90%" }}
                  options={
                    (customersInfo && Object.values(customersInfo)) || []
                  }
                  getOptionLabel={(option) =>
                    option?.customer_name?.trim() || ""
                  }
                  renderInput={(params) => {
                    return <TextField {...params} variant="outlined" />;
                  }}
                  onChange={(e, values) => {
                    if (values) {
                      dispatch(getCustomerByID(values.customer_id));
                      setCustomer_id(values.customer_id);
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Username
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  required
                  placeholder="e.g. johndoe@xyz.com"
                  value={customer_username || ""}
                  error={!!usernameError}
                  helperText={usernameError}
                  onChange={handleEmail}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography>Password</Typography>
                <Button onClick={generatePassword}>Generate Password</Button>
              </Grid>
              <Grid item xs={6}>
                <FormControl variant="outlined" size="medium" fullWidth>
                  <OutlinedInput
                    required
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    value={password || ""}
                    onChange={(e) => setPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Confirm new password
              </Grid>
              <Grid item xs={6} mt={1}>
                <FormControl variant="outlined" size="medium" fullWidth>
                  <OutlinedInput
                    required
                    fullWidth
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirm_password || ""}
                    onChange={(e) => setConfirm_password(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid> */}
            <Grid item xs={12} mt={2}>
              <LoadingButton
                loading={loading}
                loadingPosition="start"
                variant="contained"
                type="submit"
                sx={{ backgroundColor: "#282828", width: "8%" }}
                onClick={submitHandler}
              >
                Save
              </LoadingButton>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {errorAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            <AlertTitle>{errorAlertTitle}</AlertTitle>
            {errorAlertMessage}
          </Alert>
        </Snackbar>
      )}
      {error && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        </Snackbar>
      )}
      {customerLoginInfo && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            <AlertTitle>Success</AlertTitle>
            {customerLoginInfo}
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
}
